<script>
import { v4 as uuidv4 } from "uuid";
import "vue2-datepicker/index.css";
export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      value: Array.isArray(this.item_value) ? this.item_value : [],
      isModalVisible: false,
      new_item: "",
      options: [],
      leveldisplay: true,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  methods: {
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    toggleModal() {
      this.isModalVisible = !this.isModalVisible;
    },
    addPPG() {
      this.value.push({
        id: uuidv4(),
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
      });
    },
    removeItem(index) {
      this.value.splice(index, 1);
    },
  },
  computed: {
    level_two_display() {
      return this.display_none_check;
    },
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value(newVal, oldVal) {
      console.log("item_value changed from", oldVal, "to", newVal);
      this.value = newVal;
    },
    selectedItem: {
      handler() {},
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  async mounted() {
    console.log("Component mounted. Initial item_value:", this.item_value);
    this.value = this.item_value;
  },
};
</script>
<template>
  <div
    class="scheduler-input"
    :class="{ 'd-none': item.displayOn && !level_two_display }"
  >
    <b-modal
      v-model="isModalVisible"
      style="letter-spacing: 2em"
      id="add-ppg-newsletters"
      centered
      title="Add Item"
      title-class="font-18"
      hide-footer
    >
      <div class="d-flex mb-3">
        <input v-model="new_item" type="text" class="form-control mr-2" />
        <button
          class="btn btn-primary"
          @click="
            addPPG();
            $bvModal.hide('add-ppg-newsletters');
          "
        >
          Add
        </button>
      </div>
    </b-modal>
    <div class="full-width-flex">
      <div class="w100">
        <div class="label-container">
          <a
            class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center"
            role="button"
            style="color: transparent"
            >Remove</a
          >
        </div>
        <div v-for="(sg, index) in value" :key="sg.id" class="d-flex mb-2">
          <div class="row w100">
            <div class="input-section col-4">
              <input
                v-model="sg.name"
                placeholder="Name"
                type="text"
                class="form-control mb-2 mr-3"
              />
            </div>
            <div class="input-section col-4">
              <input
                v-model="sg.role"
                type="text"
                placeholder="Role"
                class="form-control mb-2 mr-3"
              />
            </div>
            <div class="input-section col-4">
              <input
                v-model="sg.email"
                placeholder="Email"
                type="text"
                class="form-control mb-2 mr-3"
              />
            </div>
          </div>
          <a
            class="font-size-14 mb-2 font-weight-medium ml-3 align-self-sm-center font-weight-medium"
            role="button"
            style="color: #da3f3f"
            v-on:click="removeItem(index)"
            >Remove</a
          >
        </div>
        <div class="mt-2">
          <a
            class="font-size-14 mb-2 ml-auto align-self-sm-center cursor-pointer font-weight-medium"
            @click="addPPG()"
            >+ Add Item</a
          >
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
          <span v-if="!validation.required">This value is required.</span>
        </div>
        <portal-target :name="item_key"> </portal-target>
      </div>
    </div>
  </div>
</template>
<style>
.mx-time-column .mx-time-list::after {
  height: 10px;
}
.section-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #333;
  padding-bottom: 20px;
}
.blue-ray-section {
  width: 20px;
  height: auto;
  background: #cad9f6;
  margin-right: 30px;
}
.full-width-flex {
  display: inline-flex;
  width: 100%;
}
.w100 {
  width: 100%;
}
.pl-10 {
  padding-left: 10px;
}
.mr-1 {
  margin-right: 1px;
}
.mt-27 {
  margin-top: 27px;
}
.label-container {
  width: 100%;
  display: flex;
}
.label-container .section-label {
  padding-bottom: 10px;
  font-weight: 500;
}
</style>
